import { colors } from 'component-library/styles/colors';
import { device } from 'component-library/styles/device';
import styled from 'styled-components';

const PERIODIC_RATE_OF_ANNUITY_GROWTH = 0.03;
const PERIODIC_RATE_OF_RETURN = 0.06;
const NUMBER_OF_PERIODS = 31;
const MONTHS_IN_YEAR = 12;

const periods = Array.from(Array(NUMBER_OF_PERIODS).keys());

export interface PaycheckChartData {
  paycheck: number;
  periodNumber: number;
  balance: number;
  age: number;
}

const calculatePaycheck = (retirementSavings: number, periodNumber: number) =>
  retirementSavings *
  ((PERIODIC_RATE_OF_RETURN - PERIODIC_RATE_OF_ANNUITY_GROWTH) /
    (1 -
      ((1 + PERIODIC_RATE_OF_ANNUITY_GROWTH) / (1 + PERIODIC_RATE_OF_RETURN)) **
        NUMBER_OF_PERIODS)) *
  (1 + PERIODIC_RATE_OF_ANNUITY_GROWTH) ** periodNumber;

export const calculatePaychecks = (
  retirementSavings: number,
  retirementAge: number,
) =>
  periods.reduce((allPeriods, periodNumber) => {
    const lastPeriod = allPeriods.slice(-1)[0];
    const lastBalance = lastPeriod?.balance || retirementSavings;
    const paycheck = calculatePaycheck(retirementSavings, periodNumber);

    allPeriods.push({
      periodNumber,
      age: retirementAge + periodNumber,
      paycheck,
      balance: lastBalance * (1 + PERIODIC_RATE_OF_RETURN) - paycheck,
    });
    return allPeriods;
  }, [] as PaycheckChartData[]);

export const sumOfAllPaychecks = (periods: PaycheckChartData[]) =>
  periods.reduce((prev, cur) => (prev += cur.paycheck), 0);

export const averagePaycheck = (periods: PaycheckChartData[]) =>
  sumOfAllPaychecks(periods) / periods.length / MONTHS_IN_YEAR;

export const PaycheckCard = styled.div`
  background: ${colors.white};
  border: 1px solid ${colors.forestGreen};
  border-radius: 2px;
  margin: 40px 0;
`;

export const BottomPanel = styled.div`
  background: ${colors.teal};
  border-top: 1px solid ${colors.forestGreen};
  padding: 40px;

  ${`@media ${device.sm}`} {
    padding: 16px;
  }
`;

export const TopPanel = styled.div`
  padding: 40px;
`;
